/**
 * @flow
 * @relayHash c389505fa1bee17d23b3bd9c0580e899
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type GraphQLExplorerConsole_graphQLSnippet$ref = any;
type GraphQLExplorerConsole_viewer$ref = any;
export type GraphQLExplorerConsoleSnippetQueryVariables = {|
  hasSnippet: boolean,
  snippet: string,
|};
export type GraphQLExplorerConsoleSnippetQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: GraphQLExplorerConsole_viewer$ref
  |},
  +graphQLSnippet?: ?{|
    +query: string,
    +operationName: ?string,
    +url: string,
    +$fragmentRefs: GraphQLExplorerConsole_graphQLSnippet$ref,
  |},
|};
export type GraphQLExplorerConsoleSnippetQuery = {|
  variables: GraphQLExplorerConsoleSnippetQueryVariables,
  response: GraphQLExplorerConsoleSnippetQueryResponse,
|};
*/


/*
query GraphQLExplorerConsoleSnippetQuery(
  $hasSnippet: Boolean!
  $snippet: String!
) {
  viewer {
    ...GraphQLExplorerConsole_viewer
    id
  }
  graphQLSnippet(uuid: $snippet) @include(if: $hasSnippet) {
    query
    operationName
    url
    ...GraphQLExplorerConsole_graphQLSnippet
    id
  }
}

fragment GraphQLExplorerConsole_viewer on Viewer {
  organizations(first: 100) {
    edges {
      node {
        id
        name
        slug
        permissions {
          pipelineView {
            allowed
            code
          }
        }
      }
    }
  }
}

fragment GraphQLExplorerConsole_graphQLSnippet on GraphQLSnippet {
  query
  operationName
  url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "hasSnippet",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "snippet",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "snippet",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "query",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "operationName",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "GraphQLExplorerConsoleSnippetQuery",
  "id": null,
  "text": "query GraphQLExplorerConsoleSnippetQuery(\n  $hasSnippet: Boolean!\n  $snippet: String!\n) {\n  viewer {\n    ...GraphQLExplorerConsole_viewer\n    id\n  }\n  graphQLSnippet(uuid: $snippet) @include(if: $hasSnippet) {\n    query\n    operationName\n    url\n    ...GraphQLExplorerConsole_graphQLSnippet\n    id\n  }\n}\n\nfragment GraphQLExplorerConsole_viewer on Viewer {\n  organizations(first: 100) {\n    edges {\n      node {\n        id\n        name\n        slug\n        permissions {\n          pipelineView {\n            allowed\n            code\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment GraphQLExplorerConsole_graphQLSnippet on GraphQLSnippet {\n  query\n  operationName\n  url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "GraphQLExplorerConsoleSnippetQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "GraphQLExplorerConsole_viewer",
            "args": null
          }
        ]
      },
      {
        "kind": "Condition",
        "passingValue": true,
        "condition": "hasSnippet",
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "graphQLSnippet",
            "storageKey": null,
            "args": v1,
            "concreteType": "GraphQLSnippet",
            "plural": false,
            "selections": [
              v2,
              v3,
              v4,
              {
                "kind": "FragmentSpread",
                "name": "GraphQLExplorerConsole_graphQLSnippet",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "GraphQLExplorerConsoleSnippetQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "organizations",
            "storageKey": "organizations(first:100)",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 100,
                "type": "Int"
              }
            ],
            "concreteType": "OrganizationConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "OrganizationEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Organization",
                    "plural": false,
                    "selections": [
                      v5,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "slug",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "permissions",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "OrganizationPermissions",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pipelineView",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Permission",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "allowed",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "code",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          v5
        ]
      },
      {
        "kind": "Condition",
        "passingValue": true,
        "condition": "hasSnippet",
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "graphQLSnippet",
            "storageKey": null,
            "args": v1,
            "concreteType": "GraphQLSnippet",
            "plural": false,
            "selections": [
              v2,
              v3,
              v4,
              v5
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5b68956c4bad3f85f82a7802d4043327';
module.exports = node;
